import React from 'react';
import AuthAdminUserModel from '../../code/models/AuthAdminUserModel';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import SystemConfig from '../../code/models/SystemConfig';
import ApiSystemConfig from '../../code/api/ApiSystemConfig';
import '../../css/adminsystemconfigurationform.css'

interface IAdminSystemConfigurationForm {
    adminUser: AuthAdminUserModel;
}

export default function AdminSystemConfigurationForm({ adminUser }: IAdminSystemConfigurationForm) {

    const [configs, setConfigs] = React.useState<SystemConfig[] | null>(null);

    React.useEffect(() => {
        loadConfigs();
    }, []);

    async function loadConfigs() {
        ApiSystemConfig.getSystemConfigs().then(data => {
            setConfigs(data);
        });
    }

    function reloadConfigs() {
        setConfigs(null);
        ApiSystemConfig.getSystemConfigs().then(data => {
            setConfigs(data);
        });
    }

    function saveConfigs() {
        if (!!configs) {
            ApiSystemConfig.updateSystemConfigs(configs).then(success => {
               if (success){
                    reloadConfigs();
               }                
            });
        }
    }

    function getButtonStateClass(isActive: Boolean, additionalClasses: string) {
        const classnames = ["btn"];
        const mainStyle = isActive ? "btn-primary" : "btn-outline-primary";
        classnames.push(mainStyle);

        if (!!additionalClasses) {
            classnames.push(additionalClasses);
        }

        return classnames.join(" ");
    }

    function formatCheckbox(val: any) {
        return (
            <input type="checkbox" readOnly checked={!val} />
          )
    }

    function checkIsEditable(rowData: any): boolean {
        return rowData.isDbSetting == true;
    }

    const profileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "name",
            title: "Name",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "value",
            title: "Value",
            visible: true,
            editable: checkIsEditable,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "isDbSetting",
            title: "Read Only",
            visible: true,
            className: "checkbox",
            formatData: formatCheckbox,
            type: CclDataTableColumnType.Data
        }
    ];

    return (
        <React.Fragment>
            <div className='buttonbar'>
                <button disabled={!configs} className={getButtonStateClass(true, "")} onClick={saveConfigs}>Save All</button>
                <button disabled={!configs} className={getButtonStateClass(true, "")} onClick={reloadConfigs}>Reload</button>
            </div>
            <div className='system-config-table-wrapper'>
                <CclDataTable
                    name={"profilesTable"}
                    tableData={configs || []}
                    columnDefinitions={profileColumnDefs}
                    rowSelect={false}
                    onRowSelect={null}
                    onButtonClick={null} />
            </div>
        </React.Fragment>
    )
}
